// libraries
import type { OfferType } from '@makemydeal/dr-platform-types';

// config
import { reducerConfig } from './reducerConfig';
import type { AnyAction } from 'redux';

export const shouldRevertPaymentOnFailure = (state: any, action: AnyAction, offerType: OfferType): boolean => {
    const shouldRevertPaymentOnFailureSelector = reducerConfig?.selectors?.shouldRevertPaymentOnFailure;
    if (shouldRevertPaymentOnFailureSelector) {
        return shouldRevertPaymentOnFailureSelector(state, action, offerType);
    }
    return false;
};
